export default {
  projectid: "",
  projectname: "projectname",
  datestring: ""
}